export type IPayment = {
    'id': string,
    'amount': number,    
    'description': string,
    'currency': string,
    'created_by': string,
    'created_date': string
}

export type IPaymentRequestPayload = Omit<IPayment, 'id' | 'created_by' | 'created_date'>;

export enum PAYMENT_ACTION_TYPE {    
    SELECT_PAYMENT = 'payment/payment-select',
    RESET_PAYMENT = 'payment/reset-payment',
    PAYMENT_LIST_UPDATE = 'payment/payment-list-update',
    PAYMENT_LIST_RESET = 'payment/payment-list-reset',
    VENDOR_SIGNATURE = 'payment/payment-vendor-signature'

};

export type IPaymentState = {
    selected: IPayment | undefined,
    list: IPayment[],
    total_amount: number,
    signature: string
};

function getInitialPaymentState(): IPaymentState {
    return {
        selected: undefined,
        list: [],
        total_amount: 0,
        signature: ''
    };
}

export function paymentReducer (state = getInitialPaymentState(), action: {type: PAYMENT_ACTION_TYPE, payload: any}) {
    switch (action.type) {
        case PAYMENT_ACTION_TYPE.VENDOR_SIGNATURE:
            return { ...state, signature: action.payload};
        case PAYMENT_ACTION_TYPE.SELECT_PAYMENT:
            return {...state, selected: action.payload};
        case PAYMENT_ACTION_TYPE.RESET_PAYMENT:
                return {...state, selected: undefined};
        case PAYMENT_ACTION_TYPE.PAYMENT_LIST_UPDATE:
            return {...state, list: action.payload};
        case PAYMENT_ACTION_TYPE.PAYMENT_LIST_RESET:
                return {...state, list: []};
        default:
            return state;
    }
}